import { Component } from '@angular/core';

/**
 * Generated class for the GiftIconComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'gift-icon',
  templateUrl: 'gift-icon.html'
})
export class GiftIconComponent {
  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/components/gift-icon/gift-icon.ts